"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Boxes = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const UiKitLite_1 = require("../UiKitLite");
const Boxes = () => (react_2.default.createElement(react_1.VStack, { align: 'stretch', spacing: 5 },
    react_2.default.createElement(UiKitLite_1.UiKitLite.InfoBox, { title: 'Title' },
        react_2.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "Box content")),
    react_2.default.createElement(UiKitLite_1.UiKitLite.InfoBox, null,
        react_2.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "Just a box with no title")),
    react_2.default.createElement(UiKitLite_1.UiKitLite.InfoBox, { title: 'Title', banner: 'banner' },
        react_2.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "This box has a banner in it's top right corner")),
    react_2.default.createElement(react_1.HStack, { spacing: 5 },
        react_2.default.createElement(UiKitLite_1.UiKitLite.InfoBox, { flex: 1, title: 'Left' },
            react_2.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "Left Box")),
        react_2.default.createElement(UiKitLite_1.UiKitLite.InfoBox, { flex: 1, title: 'Right' },
            react_2.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "Right Box")))));
exports.Boxes = Boxes;
